import { css } from '@emotion/react';

import { media } from '../shared/styles';

export const cardContainerStyles = css`
  position: relative;
  height: 335px;

  ${media.md} {
    height: 480px;
  }
`;

export const cardContentStyles = css`
  position: relative;
  border-radius: var(--spacing-4);
  overflow: hidden;
`;

export const getBackgroundWithGradient = (imageUrl: string) => css`
  background-image: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 48.36%,
      rgba(0, 0, 0, 0.6) 76.64%
    ),
    url(${imageUrl});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #fff;
`;
